import { render, staticRenderFns } from "./featuresSection.vue?vue&type=template&id=4369968a"
import script from "./featuresSection.vue?vue&type=script&lang=js"
export * from "./featuresSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports